module.exports = __webpack_public_path__ + "static/media/legalblock-org.1ad64f17.png";